<template>
  <b-modal
    id="create-ai-call-log-modal"
    centered
    hide-footer
    title="Create AI Call Log"
  >

    <b-form-group label="Customer">
      <b-form-select v-model="customer" :options="customerOptions"/>
    </b-form-group>

    <b-form-group label="Call Status">
      <b-form-select v-model="call_status" :options="statusOptions"/>
    </b-form-group>

    <b-form-group label="Duration (seconds)">
      <b-form-input type="number" v-model="duration"/>
    </b-form-group>

    <b-form-group label="Transcript">
      <b-form-textarea rows="4" v-model="transcript"/>
    </b-form-group>

    <div class="text-right mt-3">
      <b-button variant="primary" @click="submit">
        Save
      </b-button>
    </div>

  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      customer: null,
      call_status: "completed",
      duration: 0,
      transcript: "",
      customerOptions: [],
      statusOptions: [
        { value: "completed", text: "Completed" },
        { value: "no_answer", text: "No Answer" },
        { value: "failed", text: "Failed" },
      ],
    };
  },

  mounted() {
    this.fetchCustomers();
  },

  methods: {
    ...mapActions("appData", [
      "getCustomers",
      "createAICallLog"
    ]),

    async fetchCustomers() {
      const res = await this.getCustomers({ page: 1 });
      const list = (res.data && res.data.results) ? res.data.results : (Array.isArray(res.data) ? res.data : []);
      this.customerOptions = [
        { value: null, text: "Select customer..." },
        ...list.map(c => ({
          value: c.id,
          text: [c.first_name, c.last_name].filter(Boolean).join(" ") || c.name || "Unknown"
        }))
      ];
    },

    async submit() {
      await this.createAICallLog({
        customer: this.customer,
        call_status: this.call_status,
        duration: this.duration,
        transcript: this.transcript
      });

      this.$bvModal.hide("create-ai-call-log-modal");
      this.$emit("modalClosed");
    }
  }
};
</script>